const FromArr = [{
	title: "经销商：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 182,
	height: 32,
	disabled: false,
	marginLeft: 38,
	marginTop: 10,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 44,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "年度：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 52,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}]
export default FromArr;